import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// services
import { FormService } from './services/form.service';

// directives
import { ExpandingTextboxDirective } from './directives/expanding-textbox.directive';

// pipes
import { FormatYearMonthPipe } from './directives/format-year-month.pipe';

// third-party
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [
    ExpandingTextboxDirective,
    FormatYearMonthPipe,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    FontAwesomeModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    ExpandingTextboxDirective,
    FormatYearMonthPipe,
  ],
  providers: [
    FormService,
  ]
})
export class SharedModule { }
